import Splide, { Components, EventInterface } from "@splidejs/splide";

/**
 * Sets up a transition for slides that will come into play when navigating using the [Splide arrows](https://splidejs.com/guides/arrows/).
 *
 * Note: Splide already has an inbuilt transition for slides, but that transition is only used for swiping.
 *
 * @see https://splidejs.com/guides/transition/
 * @param expression CSS transition expression, e.g. "transform 300ms cubic-bezier(.6,0,0,1)"
 */
export const createSlideTransition = (expression?: string) => {
  if (!expression) return undefined;
  return (splide: Splide, components: Components) => {
    const { translate, toPosition } = components.Move;
    const { bind, unbind } = EventInterface(splide);
    const { list } = components.Elements;

    let transitionDoneCallback: () => void;
    const transitionEndHandler = (event: TransitionEvent) => {
      (event.target as HTMLElement).style.transition = "";
      transitionDoneCallback && transitionDoneCallback();
    };

    const cancel = () => (list.style.transition = "");

    const mount = () => bind(list, "transitionend", transitionEndHandler);

    const start = (index: number, doneCallback: () => void) => {
      transitionDoneCallback = doneCallback;
      list.style.transition = expression;
      translate(toPosition(index, true));
    };

    const destroy = () => unbind(list, "transitionend", transitionEndHandler);

    return {
      cancel,
      mount,
      start,
      destroy,
    };
  };
};
